import React from "react";
import TopSection from "./Components/TopSectionComponent";
import CountdownSection from "./Components/CountdownSectionComponent";
import TimelineSection from "./Components/TimelineSectionComponent";
import RSVPSection from "./Components/RSVPSectionComponent";
import DetailsSection from "./Components/DetailsSectionComponent";
import AccommodationSection from "./Components/AccomodationSectionComponent";
import HoneymoonSection from "./Components/HoneymoonSectionComponent";
import FloatingMenu from "./Components/FloatingMenuComponent";

const App = () => {
  return (
    <div className="App">
      <FloatingMenu />
      <TopSection />
      <TimelineSection />
      <DetailsSection />
      <AccommodationSection />
      <HoneymoonSection />
      <RSVPSection />
      <CountdownSection targetDate="2026-08-14T00:00:00" />
    </div>
  );
};

export default App;
